import { requestGet as wsRequestGet, requestPost as wsRequestPost, requestDelete as wsRequestDelete } from './_wsApiFetchData';

export async function searchNonPartnerFacilities({ filters }, language, timeZone, cancelToken) {
    const { id, name, slug, area, sourceType, status, reason, orderBy, orderDirection, page, resultsPerPage } = filters;

    const params = {
        id: id || undefined,
        name: name || undefined,
        slug: slug || undefined,
        area: area || undefined,
        sourceType: sourceType || undefined,
        isDeleted: status === 'active' ? false : status === 'deleted' ? true : undefined,
        isBlacklisted: status === 'blacklisted' ? true : undefined,
        reason: reason || undefined,
        orderBy: orderBy || undefined,
        orderDirection: orderDirection || undefined,
        page: page || 1,
        pageSize: resultsPerPage || 15,
    };

    return await wsRequestGet('/admin/nonpartnerfacilities/search', language, timeZone, params, cancelToken);
}

export async function lookupByName(key, language, timeZone, cancelToken) {
    if (!key) return [];
    const result = await searchNonPartnerFacilities({ filters: { name: key } }, language, timeZone, cancelToken);
    const seen = new Set();
    return result.facilities
        .filter(f => { if (seen.has(f.name)) return false; seen.add(f.name); return true; })
        .map(f => ({ label: f.name, value: f.name }));
}

export async function lookupBySlug(key, language, timeZone, cancelToken) {
    if (!key) return [];
    const result = await searchNonPartnerFacilities({ filters: { slug: key } }, language, timeZone, cancelToken);
    return result.facilities.map(f => ({ label: f.slug, value: f.slug }));
}

export async function lookupReasons(key, language, timeZone, cancelToken) {
    const result = await wsRequestGet('/admin/nonpartnerfacilities/blacklist/reasons', language, timeZone, key ? { search: key } : null, cancelToken);
    return result.map(r => ({ label: r, value: r }));
}

export async function lookupByArea(key, language, timeZone, cancelToken) {
    if (!key) return [];
    const result = await searchNonPartnerFacilities({ filters: { area: key } }, language, timeZone, cancelToken);
    const seen = new Set();
    return result.facilities
        .filter(f => { if (!f.area || seen.has(f.area)) return false; seen.add(f.area); return true; })
        .map(f => ({ label: f.area, value: f.area }));
}

export async function getNonPartnerFacility(id, language, timeZone, cancelToken) {
    return await wsRequestGet(`/admin/nonpartnerfacilities/${id}`, language, timeZone, null, cancelToken);
}

export async function addToBlacklist(nonPartnerFacilityId, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/nonpartnerfacilities/blacklist', language, timeZone, { nonPartnerFacilityId }, null, cancelToken);
}

export async function removeFromBlacklist(blacklistId, language, timeZone, cancelToken) {
    return await wsRequestDelete(`/admin/nonpartnerfacilities/blacklist/${blacklistId}`, language, timeZone, null, null, cancelToken);
}

export async function softDelete(id, language, timeZone, cancelToken) {
    return await wsRequestPost(`/admin/nonpartnerfacilities/${id}/delete`, language, timeZone, null, null, cancelToken);
}

export async function restore(id, language, timeZone, cancelToken) {
    return await wsRequestPost(`/admin/nonpartnerfacilities/${id}/restore`, language, timeZone, null, null, cancelToken);
}
